import moment from 'moment';

import { aTypeFetchProceduresBySalon } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';

// TODO: convert to the newest form using actionEndpointBe
const fetchProceduresBySalon = (id, startDate, endDate, stylistId) => {
  const params = {
    start: moment(startDate).clone().startOf('day').toISOString(),
    end: moment(endDate || startDate)
      .clone()
      .endOf('day')
      .toISOString(),
  };

  // NOTE: BE will have issues if it receives stylist field without an id
  if (stylistId) params.stylist = stylistId;

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${id}/procedures/?${fromObjectToQueryString(params)}`,
      authenticated: true,
      notifyOnError: true,
      types: fromActionTypeToArray(aTypeFetchProceduresBySalon),
      params: { id, ...params },
    },
  };
};

export default fetchProceduresBySalon;
